import { Dispatch } from '@reduxjs/toolkit';
import { sortBy } from 'lodash/fp';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Tag, TagScope } from 'dashboard/models/tag';
import { saveTags } from 'dashboard/redux/actions/tags';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadTags(tagScope: TagScope) {
  return async (dispatch: Dispatch) => {
    const params = { filter: { scope: tagScope } };

    const tagsResponse = await SessionClientDashboard.listResource<Tag, PaginationParams>(
      ApiEndpoint.Tag,
      params,
    );

    // Sort tags before saving since most places require sorted tags.
    const tags = sortBy((tag: Tag) => tag.attributes['name'], tagsResponse.data);

    dispatch(saveTags(tags, tagScope));
  };
}
